import { render } from "./MeridiemDropDown.vue?vue&type=template&id=186af9a4"
import script from "./MeridiemDropDown.vue?vue&type=script&lang=js"
export * from "./MeridiemDropDown.vue?vue&type=script&lang=js"
script.render = render

export default script